import script from "./Activities.vue?vue&type=script&setup=true&lang=js"
export * from "./Activities.vue?vue&type=script&setup=true&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=0858d8a5&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0858d8a5"]])

export default __exports__